import { render, staticRenderFns } from "./WootKeyShortcutModal.vue?vue&type=template&id=0d8dde09&scoped=true"
import script from "./WootKeyShortcutModal.vue?vue&type=script&lang=js"
export * from "./WootKeyShortcutModal.vue?vue&type=script&lang=js"
import style0 from "./WootKeyShortcutModal.vue?vue&type=style&index=0&id=0d8dde09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8dde09",
  null
  
)

export default component.exports